const SERIES_COLORS = [
  '#00F7F3', // Cyan
  '#EB4E32', // Red
  '#F5BC6F', // Orange
  '#14B8A6', // Teal
  '#8B5CF6', // Purple
  '#EC4899', // Pink
  '#10B981', // Green
];

export function getSeriesColor(series: string): string {
  if (series === 'temperatureOut') return '#F5BC6F';
  if (series === 'energy') return '#30768B';
  if (series === 'electricity') return '#3F98B4';
  if (series === 'enelyze') return '#3F98B4';
  if (series === 'mqtt') return '#7DC4DB';
  if (series === 'districtHeating') return '#266B81';
  if (series === 'forecast') return '#B4EDFF';
  if (series === 'energyPrice') return '#FF6B6B';
  if (series === 'threshold') return '#FF0000';

  const yearMatch = series.match(/\d{4}/);
  if (yearMatch) {
    const year = parseInt(yearMatch[0]);
    const index = (year - 2020) % SERIES_COLORS.length;
    return SERIES_COLORS[index];
  }

  const hash = series.split('').reduce((acc, char) => {
    return char.charCodeAt(0) + ((acc << 5) - acc);
  }, 0);

  return SERIES_COLORS[Math.abs(hash) % SERIES_COLORS.length];
}
